import { Checkbox } from 'antd';
import { ContactItemCardProps } from './bulk-messaging.types';
import { AppAvatar } from '@components/app-avatar';

function ContactItemCard(props: ContactItemCardProps) {
  const { contact, checked, onToggle, showCheckbox } = props;
  // Temporary used to determine whether contact is saved or not
  const isSavedContact = Boolean(contact.name);

  return (
    <div
      onClick={onToggle}
      className="flex cursor-pointer items-center justify-between rounded-md p-2 hover:bg-gray-200"
    >
      <div className="flex items-center gap-2.5 overflow-hidden">
        {/* If Contact is saved, Display Avatar or Name initials , else display country flag   */}
        <AppAvatar
          className="border border-gray-500!"
          size={36}
          src={isSavedContact ? contact?.avatar : contact?.countryName}
          name={isSavedContact ? contact?.name : contact?.phoneNumber}
        />

        <section className="overflow-hidden">
          <p className="max-w-52 truncate text-[15px] text-text-700">
            {/* If Contact is saved, Display Name, else display phoneNumber here */}
            {isSavedContact ? contact?.name : contact?.phoneNumber}
          </p>

          {/* If Contact is saved, Display Phone number, else display countryName here */}
          <p className="text-[13px] text-text-600">{isSavedContact ? contact?.phoneNumber : contact?.countryName}</p>
        </section>
      </div>

      {showCheckbox && (
        <Checkbox
          checked={checked}
          onClick={(e) => {
            e.stopPropagation();
            onToggle?.();
          }}
        />
      )}
    </div>
  );
}

export default ContactItemCard;
